/**
 * @generated SignedSource<<13848df5635978bca5a555e63808f372>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type DeletionReason = "AUTO" | "MANUAL";
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
import { FragmentRefs } from "relay-runtime";
export type MeetingInternalContent_meetingRecording$data = {
  readonly __typename: "MeetingRecording";
  readonly activeSummary: {
    readonly actionItems: ReadonlyArray<{
      readonly assignees: ReadonlyArray<{
        readonly fullName: string;
        readonly userId: string | null;
      }>;
      readonly text: string;
      readonly timestamp: number;
    }> | null;
    readonly activeRecapTemplate: RecapTemplateType | null;
    readonly chapters: ReadonlyArray<{
      readonly bulletPoints: ReadonlyArray<{
        readonly context: string | null;
        readonly text: string;
        readonly textShort: string | null;
        readonly timestamp: number | null;
      }>;
      readonly timestamp: number | null;
      readonly title: string;
    }> | null;
    readonly decisions: ReadonlyArray<{
      readonly text: string;
      readonly timestamp: number;
    }> | null;
    readonly id: string;
    readonly summary: string | null;
    readonly templatedRecaps: any | null;
  } | null;
  readonly clips: ReadonlyArray<{
    readonly clipEnd: number;
    readonly clipStart: number;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_ClipSummary_clip">;
  }> | null;
  readonly hasAskCopilotConversation: boolean;
  readonly id: string;
  readonly isGeneratingRecapTemplate: boolean;
  readonly meetingCallStart: string;
  readonly meetingRecordedVideoDuration: number | null;
  readonly meetingRecordedVideoUrl: string | null;
  readonly meetingRecordingVideoDeletionReason: DeletionReason | null;
  readonly note: {
    readonly title: string;
  } | null;
  readonly ownerAccount: {
    readonly __typename: string;
    readonly id: string;
  };
  readonly recordingAndTranscriptWillBeDeleted: boolean;
  readonly recordingDataAutoDeletionDate: string | null;
  readonly redactionIsInProgress: boolean;
  readonly regenerationForLanguageIsInProgress: boolean;
  readonly subtitlesVttUrl: string;
  readonly thumbnailVttUrl: string | null;
  readonly title: string;
  readonly transcript: any | null;
  readonly transcriptDeletionReason: DeletionReason | null;
  readonly url: string | null;
  readonly userVideoProgress: number;
  readonly " $fragmentSpreads": FragmentRefs<"ChaptersPanel_meetingRecording" | "ClipCutModal_meetingRecording" | "ClipsPanel_meetingRecording" | "DislikeModal_meetingRecording" | "HighlightsPanel_meetingRecording" | "Timeline_meetingKeyEvents" | "TranscriptModalContentStats" | "TranscriptModalGenerating_RedactingPreview_meetingRecording" | "TranscriptPanel_Transcript_meetingRecording" | "TranscriptVideo_meetingRecording">;
  readonly " $fragmentType": "MeetingInternalContent_meetingRecording";
};
export type MeetingInternalContent_meetingRecording$key = {
  readonly " $data"?: MeetingInternalContent_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingInternalContent_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "public",
    "value": false
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./MeetingInternalContentQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "MeetingInternalContent_meetingRecording",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitlesVttUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingSummary",
      "kind": "LinkedField",
      "name": "activeSummary",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptChapter",
          "kind": "LinkedField",
          "name": "chapters",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptBulletPoint",
              "kind": "LinkedField",
              "name": "bulletPoints",
              "plural": true,
              "selections": [
                (v4/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "textShort",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "context",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptActionItem",
          "kind": "LinkedField",
          "name": "actionItems",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptActionItemAssignee",
              "kind": "LinkedField",
              "name": "assignees",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptDecision",
          "kind": "LinkedField",
          "name": "decisions",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeRecapTemplate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templatedRecaps",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingClip",
      "kind": "LinkedField",
      "name": "clips",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clipStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clipEnd",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ClipsPanel_ClipSummary_clip"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGeneratingRecapTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redactionIsInProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regenerationForLanguageIsInProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAskCopilotConversation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailVttUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordingAndTranscriptWillBeDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcriptDeletionReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordingVideoDeletionReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordingDataAutoDeletionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userVideoProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClipCutModal_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Timeline_meetingKeyEvents"
    },
    {
      "args": (v5/*: any*/),
      "kind": "FragmentSpread",
      "name": "HighlightsPanel_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChaptersPanel_meetingRecording"
    },
    {
      "args": (v5/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptVideo_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClipsPanel_meetingRecording"
    },
    {
      "args": (v5/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_Transcript_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DislikeModal_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptModalContentStats"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptModalGenerating_RedactingPreview_meetingRecording"
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};
})();

(node as any).hash = "a454ebfba0fe0b9756423476d84d9825";

export default node;
